import React from "react";
import { useSelector } from "react-redux";
import TemplateCreationBody from "../TemplateCreationBody";
import AuthenticationMainBody from "../Authentication/AuthenticationMainBody";

const SecondStepMainBody = () => {
  const selectedCategory = useSelector(
    (state) => state.templateCreation.selectedCategory
  );

  switch (selectedCategory) {
    case "Utility":
      return <TemplateCreationBody />;
    case "Authentication":
      return <AuthenticationMainBody />;
    case "Marketing":
      return <TemplateCreationBody />;
    default:
      return <TemplateCreationBody />;
  }
};

export default SecondStepMainBody;
